<template>
  <a-select
    mode="multiple"
    v-model:value="valueState"
    style="width: 300px"
    placeholder="Pilih Sub Category"
    allow-clear
    not-found-content="Tidak ditemukan"
    option-filter-prop="label"
    option-label-prop="label"
    @search="onSearch"
    @blur="() => (findText = null)"
    @select="() => (findText = null)"
    v-bind="$attrs"
    :loading="loading"
    :show-arrow="true"
  >
    <a-select-option v-for="d in dataRegional" :key="d.id" :label="d.name">
      <!-- eslint-disable vue/no-v-html -->
      <span v-html="highlight(d.name)"></span>
      <!--eslint-enable-->
    </a-select-option>
  </a-select>
</template>

<script>
import { onMounted, ref, toRefs, reactive, watch } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce } from 'lodash'

export default {
  props: {
    value: {
      default: () => [],
      type: Array,
    },
    category: {
      default: () => [],
      type: Array,
    },
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const dataRegional = ref([])
    const findText = ref(null)
    const category = toRefs(props).category
    const loading = ref(false)

    const fetchDataRegional = (category, q = null) => {
      if (category != null && category.length <= 0) category = null
      loading.value = true
      apiClient
        .get('/api/filter/sub-category?active=1', { params: { category: category, q } })
        .then(response => {
          const sorted = response.data
          dataRegional.value = sorted.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
          )
        })
        .finally(() => {
          loading.value = false
        })
    }
    onMounted(() => {
      fetchDataRegional(category.value)
    })
    watch(category, (after, before) => {
      emit('update:value', [])
      fetchDataRegional(after)
    })

    const onSearch = debounce(value => {
      loading.value = true
      console.log({ value, findText: findText.value })
      findText.value = value
      fetchDataRegional(category.value, value)
    }, 300)

    const highlight = value => {
      return value.replace(new RegExp(findText.value, 'gi'), match => {
        return `<span style="background-color: yellow;">${match}</span>`
      })
    }
    return {
      dataRegional,
      valueState: useVModel(props, 'value'),
      findText,
      highlight,
      onSearch,
      loading,
    }
  },
}
</script>

<style></style>
